import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  engineValidation,
  mileageValidation,
  textLimitValidation,
  vinValidation,
  yearValidation,
} from '../../../utils/validations';
import Input from '../../shared/input/Input';
import SpecificationSelect from '../../shared/select/SpecificationSelect';
import BrandSelect from '../../shared/select/brand/BrandSelect';
import ClientSelect from '../../shared/select/client/ClientSelect';
import ModelSelect from '../../shared/select/model/ModelSelect';
import RateSelect from '../../shared/select/rate/RateSelect';

const VehicleForm = ({ onSubmit, vehicle, loading, specifications, isUpdating }) => {
  const methods = useForm({ defaultValues: vehicle });
  return (
    <FormProvider {...methods}>
      <form
        id="vehicle-form"
        noValidate
        className="modal-form"
        onSubmit={methods.handleSubmit((data) => onSubmit(data))}
      >
        <Input
          label="VIN"
          type="input"
          name="vin"
          autoFocus="true"
          disabled={loading || isUpdating}
          placeholder="Введіть VIN код"
          validation={vinValidation}
        />
        <InfoContainer>
          <ClientSelect disabled={loading} />
          <RateSelect disabled={loading} />
        </InfoContainer>
        <InfoContainer>
          <BrandSelect disabled={loading || isUpdating} />
          <ModelSelect disabled={loading || isUpdating} />
        </InfoContainer>
        <hr className="mt-2 md:mt-4" />
        <InfoContainer>
          <Input
            label="Державний номер"
            type="input"
            name="number"
            disabled={loading}
            placeholder="Введіть державний номер"
            validation={textLimitValidation}
          />
          <Input
            label="Рік"
            type="input"
            name="year"
            disabled={loading}
            placeholder="Введіть рік випуску"
            validation={yearValidation}
          />
        </InfoContainer>
        <InfoContainer>
          <Input
            label="Пробіг"
            type="number"
            name="mileage"
            disabled={loading}
            placeholder="Введіть пробіг"
            validation={mileageValidation}
          />
          <Input
            label="Об'єм двигуна"
            type="number"
            name="engine"
            disabled={loading}
            placeholder="Введіть об'єм двигуна"
            validation={engineValidation}
          />
        </InfoContainer>
        <InfoContainer>
          <SpecificationSelect
            name="transmission"
            label="Тип трансмісії"
            options={specifications.transmissionTypes}
            placeholder="Виберіть трансмісію"
            disabled={loading}
          />
          <SpecificationSelect
            name="color"
            label="Колір"
            options={specifications.colorTypes}
            placeholder="Виберіть колір"
            disabled={loading}
          />
        </InfoContainer>
        <InfoContainer>
          <SpecificationSelect
            name="fuel"
            label="Тип палива"
            options={specifications.fuelTypes}
            placeholder={'Виберіть тип палива'}
            disabled={loading}
          />
          <SpecificationSelect
            name="wheelDrive"
            label="Тип приводу"
            options={specifications.wheelDriveTypes}
            placeholder="Виберіть привід"
            disabled={loading}
          />
        </InfoContainer>
      </form>
    </FormProvider>
  );
};

const InfoContainer = ({ children }) => (
  <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-8">{children}</div>
);

export default VehicleForm;
